import { PrefixedSelect, SelectOption } from '../PrefixedSelect';

// Mock data for episodes - to be replaced with real data later
const MOCK_EPISODES = [
  { id: 'ep-1', name: 'Episode 1: Introduction' },
  { id: 'ep-2', name: 'Episode 2: Deep Dive' },
  { id: 'ep-3', name: 'Episode 3: Conclusion' },
];

export type Episode = {
  id: string;
  name: string;
};

export type EpisodeFilter = 'all' | Episode | undefined;

type EpisodesFilterProps = {
  selectedEpisode?: EpisodeFilter;
  onApply: (selectedEpisode: EpisodeFilter) => void;
  onOpen?: () => void;
  renderAllEpisodes?: boolean;
};

const getEpisodeParam = (episode: EpisodeFilter): string => {
  if (episode === 'all' || episode === undefined) return 'all';
  return episode.id;
};

const EpisodesFilter = ({
  selectedEpisode = 'all',
  onApply,
  onOpen,
  renderAllEpisodes = true,
}: EpisodesFilterProps) => {
  const handleApply = (selectedEpisode: EpisodeFilter) => {
    onApply(selectedEpisode);
  };

  const handleOpen = () => {
    onOpen?.();
  };

  const displayLabel =
    selectedEpisode === 'all' || !selectedEpisode
      ? 'Episode: All'
      : `Episode: ${selectedEpisode.name}`;

  return (
    <PrefixedSelect
      displayLabel={displayLabel}
      placeholder="Episodes"
      value={getEpisodeParam(selectedEpisode)}
      onClick={handleOpen}
      onChange={(event) => {
        const selectedValue = (event.target as HTMLSelectElement).value;
        const episode =
          selectedValue === 'all'
            ? 'all'
            : (() => {
                const foundEpisode = MOCK_EPISODES.find((ep) => ep.id === selectedValue);
                return foundEpisode
                  ? {
                      id: foundEpisode.id,
                      name: foundEpisode.name,
                    }
                  : undefined;
              })();

        handleApply(episode);
      }}
    >
      {renderAllEpisodes && <SelectOption value="all">All</SelectOption>}
      {MOCK_EPISODES.map((episode) => (
        <SelectOption key={episode.id} value={episode.id}>
          {episode.name}
        </SelectOption>
      ))}
    </PrefixedSelect>
  );
};

export default EpisodesFilter;
